<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 v-if="mutateViewModel.isNew" class="modal-title">{{$t("フォーム登録.1")}}</h4>
    <h4 v-else class="modal-title">{{$t("フォーム登録.14")}}</h4>
  </div>
  <div class="p-3 overflow-auto pt-2" style="max-height:80vh;border-top:0px solid silver;border-bottom:0px solid silver;" v-if="mutateViewModel">   
      <div class="pl-1" >
        <div class="pb-2" v-if="mutateViewModel.backImage">
          <el-form :ref="`formSetting`" :rules="rules" :model="mutateViewModel.backImage.backImage" label-position="top">
          <div class="d-flex flex-column mb-3">
            <h4 class="formInput-section">{{$t("フォーム登録.2")}} <require-tag /></h4>
            <el-form-item class="flex-grow-1" prop="inspectMasterList" >
              <el-select placeholder=""
                class="w-100"
                v-model="mutateViewModel.backImage.backImage.inspectMasterList"
                @change="chengeInspectMaster"
                multiple
                :disabled="!mutateViewModel.isNew"
                filterable>
                <el-option v-for="item in mutateViewModel.formList"
                          class="select-primary"
                          :value="item.inspectMaster.id"
                          :label="item.inspectMaster.name"
                          :key="item.inspectMaster.name">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="d-flex flex-column mb-3">
            <div>
              <h4 class="formInput-section">{{$t('フォーム登録.3')}} <require-tag /></h4>
            </div>
            <el-form-item prop="name">
              <el-input v-model="mutateViewModel.backImage.backImage.name"></el-input>
            </el-form-item>
          </div>
          <div class="d-flex flex-column mb-3">
            <h4 class="formInput-section">{{$t('フォーム登録.4')}}</h4>
            <el-radio-group v-model="mutateViewModel.treeItem.treeItem.type" class="d-inline-flex justify-content-left col-12 w-100" :disabled="!mutateViewModel.isNew">
              <el-radio
                class="font-size-middle "
                @change="onChangeBackType"
                v-for="item in backTypes"
                :key="item.nodeTypeKey"
                :label="item.nodeTypeKey">
                {{item.label}}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="d-flex flex-column mb-3" v-if="mutateViewModel.treeItem.treeItem.type == 'backimage'">
            <h4 class="formInput-section">{{$t('フォーム登録.8')}}</h4>
            <el-radio-group v-model="backImageSource" class="d-inline-flex justify-content-left col-12 w-100" :disabled="!mutateViewModel.isNew">
              <el-radio
                class="font-size-middle"
                @change="onChangeSourceType"
                v-for="item in backImageSourceType"
                :key="item.id" 
                :label="item.id">
                {{item.label}}
              </el-radio>
            </el-radio-group>
            <el-select placeholder=""
              class="flex-fill ml-3"
              v-if="backImageSource == '1' && mutateViewModel.treeItem.treeItem.type == 'backimage'"
              v-model="originBackImageSk">
              <el-option v-for="item in mutateViewModel.backImageCopySourceList"
                        class="select-primary"
                        :value="item.sk"
                        :label="item.backImage.name"
                        :key="item.sk">
              </el-option>
            </el-select>
          </div>
          <!-- 背景図アップロード(図面を使用する場合) -->
          <div class="d-flex flex-column pl-3 pr-3" v-if="backImageSource == '0' && mutateViewModel.treeItem.treeItem.type == 'backimage'" >
            <div v-if="!mutateViewModel.isNew" class="mb-2">設定中の背景図: {{lastBackImageName}}</div>
            <el-upload
              class="flex-fill w-100 justify-content-left align-items-baselin upload-conainer"
              action=""
              drag
              v-if="uploadFiles.length == 0"
              ref="upload"
              :auto-upload="false"
              :file-list="uploadFiles"
              :thumbnail-mode="true"
              :on-change="addFile"
              :on-remove="removeFile"
              :disabled="uploadFiles.length > 0"
              :multiple="false"
            >
              <div class="d-flex flex-column">            
                <div class="d-flex ">
                  <div class="align-self-center">ここにファイルをドラッグ＆ドロップ、または</div>
                  <div class="flex-fill">
                    <el-button size="small" type="primary" class="bg-primary border-0 ml-2 mr-2 mt-3 mb-3"><span style="font-size:1.2rem;">背景図ファイルを選択</span></el-button>
                    
                  </div>
                </div>
                <div style="font-size:0.8rem;">1ファイル100MBまでアップロードできます</div>
              </div>
              
            </el-upload>

            <div class="d-flex" v-if="uploadFiles.length > 0">
              <div class="flex-grow-1">
                選択したファイル：{{uploadFiles[0].name}}
              </div>
              
              <base-button
                type="primary"
                @click="onClickRemoveFile"
                >ファイルを削除する</base-button
              >
            </div>
          </div>

          <!-- 地図タイプの選択(地図を使用する場合) -->
          <div class="d-flex flex-column mb-3" v-if="false && mutateViewModel.treeItem.treeItem.type == 'map'">
            <h4 class="formInput-section">{{$t('フォーム登録.8')}}</h4>
            <el-radio-group v-model="mapSource" class="d-inline-flex justify-content-left col-12 w-100">
              <el-radio
                class=""
                v-for="item in mapType"
                :key="item.nodeTypeKey"
                :label="item.label">
                {{item.label}}
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 作図コピーの選択 -->
          <div class="font-size-middle ml-3" v-if="(mutateViewModel.treeItem.treeItem.type == 'map' || (mutateViewModel.treeItem.treeItem.type == 'backimage' && backImageSource == '1')) && mutateViewModel.isNew">
            <el-checkbox v-model="mutateViewModel.isCopyShape" class="text-primary mr-1" label="" size="large" />{{$t('フォーム登録.12')}}
          </div>
          <div class="d-flex flex-column ml-3" v-if="mutateViewModel.isCopyShape && mutateViewModel.treeItem.treeItem.type == 'map' ">
            <div>{{$t('フォーム登録.13')}}</div>
            <el-select placeholder=""
              class="flex-fill"
              v-model="originBackImageSk">
              <el-option v-for="item in mutateViewModel.backImageCopySourceList"
                        class="select-primary"
                        :value="item.sk"
                        :label="item.backImage.name"
                        :key="item.sk">
              </el-option>
            </el-select>
          </div>
          </el-form>
        </div>   
      </div>
    </div>
    
      <div class="d-flex p-3">
        <div class="my-box flex-fill pr-1">
          <base-button
            block
            type="secondary"
            @click="onClickCancel"
            >{{$t("共通.13")}}</base-button
          >
        </div>
        <div class="my-box flex-fill pl-1">
          <base-button
            block
            type="primary"
            @click="onClickSave"           
            >{{$t("共通.14")}}</base-button
          >
        </div>
      </div>
      <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1051 !important;" body-classes="p-0">
        <confirm-modal 
          :title="confirm.title"
          :message="confirm.message" 
          :leftButtonLabel="confirm.leftButtonLabel" 
          :rightButtonLabel="confirm.rightButtonLabel" 
          @onClickLeftButton="onClickConfirmLeft"
          @onClickRightButton="onClickConfirmRight"
        />
      </modal>
    
  
</template>
<style>
.upload-conainer .el-upload {
  width:100%;
}
.upload-conainer .el-upload-dragger {
  height:auto !important;
  width: auto !important;
  padding:1rem;
}

</style>
<style scoped>
</style>

<script>
import ValidateUtil from "@/appUtils/ValidateUtil"
import TenantStorage from "@/appUtils/TenantStorage"
import { useToast } from "vue-toastification";
import FormSettingViewModel from "@/appViews/components/FileView/ViewModel/FormSettingViewModel"
import mime from 'mime-types';
const path = require('path')

export default {
  components: {
  },
  props: {
    viewModel: {
      type: Object
    }
  },
  watch: {
    mutateViewModel: {
      handler: function () {
        this.modified = true
      },
      deep: true
    }
  },
  data() {
    return {
      tenantId: null,
      parentSk: null,
      loader: null,
      targetNodeId: null,
      mutateViewModel: null,
      showConfirm: false,
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      backImageSource: "0",
      modified: false,
      uploadFiles: [],
      iconKeyToPath: {},
      tenantStorage: null,
      rules: {
        name: [{ required: true, validator: this.checkBackImageName, trigger: 'blur' }],
        inspectMasterList: [{ required: true, validator: this.checkInspectMasterList, trigger: 'blur' }]
      },
      toastId: "inspectIconModal",
      backTypes: [{
        id: 0,
        nodeTypeKey: "backimage",
        label: "図面",
        memo: "PDFまたは画像(png / jpeg)ファイルを背景図に表示します。",
      }, {
        id: 1,
        nodeTypeKey: "map",
        label: "地図",
        memo: "国土地理院の地図を背景図に表示します。",
      }, {
        id: 2,
        nodeTypeKey: "nobackimage",
        label: "背景図なし",
        memo: "背景図を表示しない一覧だけの検査です。",
      }],
      backImageSourceType: [
        {id: "0", label: `${this.$t('フォーム登録.9')}`},
        {id: "1", label: `${this.$t('フォーム登録.10')}`}
      ],
      mapType: [
        {id: 0, label: "国土地理院"}
      ],
      isCopyBackImage: false,
      isFigureCopy: false,
      originBackImageSk: "",
      lastBackImageKey: "",
      lastBackImageName: ""
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
    this.init().then(function(){
      console.log(``)
    })
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      try {
        const tenantStore = this.$store.state.tenant
        this.tenantId = tenantStore.id
        this.tenantStorage = new TenantStorage(this.tenantId)
        // this.uploadFiles = []
        // ViewModelをプロパティのオブジェクトから初期化
        await this.initViewModel()
        this.modified = false
        
      } catch (e){
        console.log(JSON.stringify(e.stack, null, "\t"))
        throw e
      
      }
    },
    chengeInspectMaster(){

    },
    async initViewModel() {
      
      if (!this.viewModel) {
        return
      }
      this.mutateViewModel = new FormSettingViewModel()
      this.mutateViewModel = Object.assign(this.mutateViewModel, JSON.parse(JSON.stringify(this.viewModel)))
      
      await this.mutateViewModel.init()
      
      if (this.mutateViewModel.backImage.backImage.filePath) {
      
        // 背景図差し替え時には削除するため、S3Keyを退避させておく
        this.lastBackImageKey = this.mutateViewModel.backImage.backImage.filePath
        this.lastBackImageName = path.basename(this.lastBackImageKey)
      } else {
        this.uploadFiles = []
      }

    },
    /**
     * モーダルのキャンセル
     */
    onClickCancel() {
      if (this.modified) {
        // 変更確認
        this.confirm.message = `変更内容が破棄されますがよろしいですか？`
        this.confirm.leftButtonLabel = "編集に戻る"
        this.confirm.rightButtonLabel = "破棄する"
        this.confirm.leftButtonFn = function() {
          this.showConfirm = false
        }.bind(this)
        this.confirm.rightButtonFn = function() {
          this.showConfirm = false
          this.$emit("onCancel");
        }.bind(this)
        this.showConfirm = true
      } else {
        this.$emit("onCancel");
      }
      
    },
    addFile(file) {
      // 前回のファイルをクリア
      this.removeFile();

      // サイズオーバーか
      const sizeMb = file.size / 1024 / 1024;
      const isOverSize = sizeMb > 100;

      if (isOverSize) {
        this.runToast("ファイルサイズが100MBを超えています。", "error")
        this.$refs.upload.clearFiles();
        this.uploadFiles = [];
        return
      }

      // ファイル拡張子チェック
      let contentType = mime.lookup(file.name)
            
      if (contentType != "application/pdf" && contentType != "image/jpeg" && contentType != "image/png") {
        this.runToast("対応していないファイル形式です", "error")
        this.$refs.upload.clearFiles();
        this.uploadFiles = [];
        return
      }
      
      this.uploadFiles.push(file)

    },
    onSelectBackType(selectValue) {
      
      this.backTypes.forEach(function(item) {
        if (item.label == selectValue)[
          this.mutateViewModel.treeItem.treeItem.type = item.nodeTypeKey
        ]
      }.bind(this))
      
    },
    onSelectSourceType(select) {
      let sourceTypes = this.backImageSourceType.filter(function(item) {
        return item.label = select
      }.bind(this))
      
      if (sourceTypes.length > 0) {
        this.backImageSource = sourceTypes[0].id
      }
    },
    removeFile() {
      // 前回のファイルをクリア
      this.$refs.upload.clearFiles();
      this.uploadFiles = [];
    },
    /**
     * 背景図をアップロード
     */
    async uploadFile() {
      // ファイル指定がない
      if (this.uploadFiles.length == 0) {
        return false
      }
      // ファイル指定はあるが実体が無い
      const file = this.uploadFiles[0];
      if (!file.raw) {
        return false
      }
      try {
        const projectId = this.mutateViewModel.projectId
        const nodeId = this.mutateViewModel.nodeId
        if (!this.tenantId || !projectId || !nodeId) {
          throw `パラメータ不足`  
        }
        // S3キー名
        const fileName = file.name
        const s3Key = this.tenantStorage.createBackImageKey(projectId, nodeId, fileName)
        
        const fileBody = file.raw

        let contentType = mime.lookup(file.name)
        const option = {"ContentType": contentType}

        try {
          // S3バケットにファイルを保存
          await this.tenantStorage.put(s3Key, fileBody, option)
        } catch (e) {
          console.log(`S3アップロード失敗 ${e.stack}`)
          throw e
        }
        // 更新データにファイル名とキーをセット
        this.mutateViewModel.backImage.backImage.filePath = s3Key

        return true

      } catch (e) {
        alert(e.message)
        throw e
      }
    },
    
    async deleteFile(s3key) {
      try {
        // もしなければ終了
        if (!s3key) {
          return
        }
        
        await this.tenantStorage.delete(s3key)

      } catch (e) {
        console.log(`削除失敗 ${JSON.stringify(e)}`)
      }
    },
    async onChangeBackType(value) {

    },
    async onChangeSourceType(value) {
      
      switch (value) {
      case "0":
        // アップロードを選択時はコピー元選択値をクリア
        this.uploadFiles = [];
        setTimeout(function() {
          this.$refs.upload.clearFiles();
        }.bind(this), 100)
        
        break;
      case "1":
        // 登録済みから選択時はアップロードファイルをクリア
        this.originBackImageSk = ""
      }

    },
    /**
     * モーダルの保存
     */
    async onClickSave() {
      this.hideToast()
      this.showLoader()
      try {
        this.$refs.formSetting.validate(async function(result, object) {
          let isUploaded = false
          try {

            if (!result) {
              this.runToast("入力内容にエラーがあります。", "error")
              this.hideLoader()
              return
            }
            // 背景図チェック
            if (this.mutateViewModel.isNew && this.mutateViewModel.treeItem.treeItem.type == 'backimage' && this.backImageSource == '0' && this.uploadFiles.length == 0) {
              this.runToast("背景図ファイルを指定してください。", "error")
              this.hideLoader()
              return
            }
            // フォーム選択チェック
            if (this.mutateViewModel.backImage.backImage.inspectMasterList.length == 0) {
              this.runToast("フォームを設定して下さい。", "error")
              this.hideLoader()
              return
            }
            // コピー元背景図選択チェック
            if (this.mutateViewModel.isNew && this.mutateViewModel.treeItem.treeItem.type == 'backimage' && this.backImageSource == '1' && !this.originBackImageSk) {
              this.runToast("コピー元のフォームを選択してください。", "error")
              this.hideLoader()
              return
            }
            // 背景図をアップロード
            isUploaded = await this.uploadFile()
            
            // DB更新
            if (this.originBackImageSk) {
              const origin = this.mutateViewModel.backImageCopySourceList.filter(function(item) {
                return item.sk == this.originBackImageSk
              }.bind(this))
              if (origin.length > 0){
                this.mutateViewModel.originBackImage = origin[0]
              }
            }
            await this.mutateViewModel.save()
            
            // すべて正常終了時に古い背景図が存在しており異なるパスであれば削除する
            if (isUploaded && this.lastBackImageKey && this.mutateViewModel.backImage.backImage.filePath != this.lastBackImageKey) {
              await this.deleteFile(this.lastBackImageKey)
            }

            // ローディング終了
            this.hideLoader()
            // 親ビューに通知
            this.$emit("onSave");

          } catch (e) {
            // エラー時
            this.hideLoader()
            this.runToast("フォーム作成時にエラーが発生しました", "error")
            // アップロード済みファイルがあれば削除
            if (isUploaded) {
              await this.deleteFile(this.mutateViewModel.backImage.backImage.filePath)
            }
            
          }
        }.bind(this))
      } catch (e) {
        this.runToast("フォーム作成時にエラーが発生しました", "error")
        this.hideLoader()
        throw e
      }
    },
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    
    /**
     * 表示名の入力チェック
     */
    async checkName(rule, value, callback){
      if (ValidateUtil.checkBase(value, callback, 50, true, false, false)) {
        callback()
      }
    },
    async checkBackImageName(rule, value, callback){
      if (ValidateUtil.checkBase(value, callback, 50, true, false, false)) {
        callback()
      }
    },
    async checkInspectMasterList(rule, value, callback){
      if (ValidateUtil.checkBase(value, callback, 0, true, false, false, false)) {
        callback()
      }
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },
    onClickRemoveFile(){
      // this.$refs.upload.clearFiles()
      this.uploadFiles = []
      this.$nextTick(function(){
        this.$refs.upload.clearFiles()
      }.bind(this))
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.loader.hide();
    },
    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },
    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    }
  }
};
</script>